/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { ActionContext, ActionTree } from "vuex";
import { IRootState } from "./state";
import { IMutations } from "./mutations";
import { RootStore } from "@/store/constants";

export enum Actions {
  INITIALIZED = "INITIALIZED",
  SET = "SET"
}

export type AugmentedActionContext = {
  commit<K extends keyof IMutations>(
    key: K,
    payload: Parameters<IMutations[K]>[1]
  ): ReturnType<IMutations[K]>;
} & Omit<ActionContext<IRootState, IRootState>, "commit">;

export interface IActions {
  [Actions.INITIALIZED]({ commit }: AugmentedActionContext): void;
  [Actions.SET]({ commit }: AugmentedActionContext, payload: boolean): void;
}

export const actions: ActionTree<IRootState, IRootState> & IActions = {
  [Actions.INITIALIZED]({ commit }) {
    commit(RootStore.Mutations.SET_INITIALIZED, true);
  },
  [Actions.SET]({ commit }, isRoot: boolean) {
    commit(RootStore.Mutations.SET, isRoot);
  }
}